import * as React from 'react';
import { SVGProps } from 'react';

const SvgOverview = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#overview_svg__a)' fill='#000'>
      <path d='M19.5 15.75H18v3.75h1.5v-3.75ZM16.5 12H15v7.5h1.5V12ZM8.25 19.5a3.755 3.755 0 0 1-3.75-3.75H6a2.25 2.25 0 1 0 2.25-2.25V12a3.75 3.75 0 0 1 0 7.5Z' />
      <path d='M21 1.5H3A1.502 1.502 0 0 0 1.5 3v18A1.502 1.502 0 0 0 3 22.5h18a1.502 1.502 0 0 0 1.5-1.5V3A1.502 1.502 0 0 0 21 1.5Zm0 6.75H10.5V3H21v5.25ZM9 3v5.25H3V3h6ZM3 21V9.75h18L21.002 21H3Z' />
    </g>
    <defs>
      <clipPath id='overview_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgOverview;
